import Vue from "vue";
import VueI18n from "vue-i18n";
import { xLocalStorage } from "@/core/services/xLocalStorage.service";

// Localisation language list
import fa from "@/core/config/i18n/fa";

Vue.use(VueI18n);

let messages = {};
messages = { ...messages, fa };

// get current selected language
const lang = xLocalStorage.get("language") || "fa";

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: lang, // set locale
  messages // set locale messages
});

export default i18n;
